import Vue from 'vue';
import { gsap } from 'gsap';
import Errors from '../classes/Errors';
import Grid from '../classes/infinityGrid.js';

Vue.component('pitches-grid-component', {
    props: [
        'pitches'
    ],
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
            infinityGrid: null,
            pitchesObj: null,
            latestPitch: null,
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        this.pitchesObj = JSON.parse(this.pitches);

        this.latestPitch = this.pitchesObj[0]

        Vue.nextTick(() => {
            this.setupGridSimple();
        })


        EventBus.$on('window-resize', () => {

            var gridContainer = document.querySelector(".grid-container");
            gridContainer.innerHTML = "";
            this.setupGridSimple()
        });

    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {
    
        createElement() {
            let randomImg = this.pitchesObj[Math.round(Math.random()*(this.pitchesObj.length-1))];
            const translateXOptions = ['-16%', '12%', '14%', '-10%', '0%', '0%', '-10%', '-10%', '-7%', '15%', '7%', '-15%']
            const translateYOptions = ['-16%', '12%', '14%', '-10%', '0%', '0%', '-10%', '-10%', '-7%', '15%', '7%', '-15%']

            let c = document.createElement('div');
            let h = document.createElement('div');
            h.className = 'card__content-holder';
            let drag
            h.onmousedown = () => {
                drag = false
            }
            h.onmousemove = () => {
                drag = true
            }
            h.onmouseup = () => {
                console.log('DRAG = ', drag)
                if(!drag) {
                    window.location.href = randomImg.url;
                    // this.$router.push(randomImg.url)
                } else {
                    console.log('MOVED so do nothing')
                }
            }
            // h.href = randomImg.url;
            h.style.transform = `translate(${translateXOptions[Math.round(Math.random()*(translateXOptions.length-1))]}, ${translateYOptions[Math.round(Math.random()*(translateYOptions.length-1))]})`;

            var pictureElement = document.createElement( 'picture' );
            var imgHolderElement = document.createElement( 'div' );
            imgHolderElement.className = 'card__image-holder';

            if (randomImg.pitchImageWebP) {
                if(randomImg.pitchImageWebP.length > 1) {
                    var srcElementWebP1 = document.createElement( 'source' );
                    srcElementWebP1.dataset.srcset = randomImg.pitchImageWebP[1].url;
                    srcElementWebP1.srcset = randomImg.pitchImageWebP[1].url;
                    srcElementWebP1.type="image/webp";
                    srcElementWebP1.media="(min-width: 768px) and (orientation: landscape)";
                    pictureElement.appendChild( srcElementWebP1 );
                }
                if(randomImg.pitchImageWebP.length > 0) {
                    var srcElementWebP0 = document.createElement( 'source' );
                    srcElementWebP0.dataset.srcset = randomImg.pitchImageWebP[0].url;
                    srcElementWebP0.srcset = randomImg.pitchImageWebP[0].url;
                    srcElementWebP0.type="image/webp";
                    pictureElement.appendChild( srcElementWebP0 );
                }
            }
            if(randomImg.pitchImage.length > 1) {
                var srcElement1 = document.createElement( 'source' );
                srcElement1.dataset.srcset = randomImg.pitchImage[1].url;
                srcElement1.srcset = randomImg.pitchImage[1].url;
                srcElement1.media="(min-width: 768px) and (orientation: landscape)";
                pictureElement.appendChild( srcElement1 );
            }

            var imgElement = document.createElement( 'img' );
            imgElement.className = 'card__image';
            imgElement.src = randomImg.pitchImage[0].url;
            imgElement.style.width = "100%";
            imgElement.style.height = "100%";
            pictureElement.appendChild( imgElement );

            imgHolderElement.appendChild( pictureElement );

            var titleElement = document.createElement( 'div' );
            titleElement.className = 'name-small card-title';
            titleElement.innerText = randomImg.title;

            if (this.latestPitch.id == randomImg.id) {
                var sticker = document.createElement( 'div' );
                sticker.className = 'card-sticker';

                var stickerImage = document.createElement( 'img' );
                stickerImage.className = 'card-sticker__image';
                stickerImage.src = '/media/images/white-star-sticker.svg'

                var stickerText = document.createElement( 'div' );
                stickerText.className = 'cta-small card-sticker__text';
                stickerText.innerText = 'latest pitch';
                sticker.appendChild( stickerImage );
                sticker.appendChild( stickerText );
                h.appendChild( sticker );
            }

            h.appendChild( imgHolderElement );
            h.appendChild(titleElement)
            c.appendChild( h );
            c.style.width = "100%";
            c.style.height = "100%";

            c.className = 'card';
            
            // Apply faded style for archived pitches
            if (randomImg.isArchived) {
                c.classList.add('card--archived');
            }
            
            return c;
        },
    
        setupGridSimple() {
            
            // let itemWidth = this.vwTOpx(this.$root.isMobile ? 90 : 55)
            let itemWidth = 314
            if(window.innerWidth >= 768) {
                itemWidth = 504
            }
            if(window.innerWidth >= 1280) {
                itemWidth = 580
            }
            if(window.innerWidth >= 1440) {
                itemWidth = 630
            }
            // let itemHeight = this.vwTOpx(this.$root.isMobile ? 66 : 44)
            let itemHeight = 325
            if(window.innerWidth >= 768) {
                itemHeight = 435
            }
            if(window.innerWidth >= 1280) {
                itemHeight = 494
            }
            if(window.innerWidth >= 1440) {
                itemHeight = 530
            }
            
            this.infinityGrid = new Grid({
                width: itemWidth,
                height: itemHeight,
                mouse: true,
                zoom: false, //disable or enable the zoom (default = false)
                body: document.querySelector('#infinity-grid'),
                createElementFunction: this.createElement
            });


        },

        // vwTOpx(value) {
        //     var w = window,
        //       d = document,
        //       e = d.documentElement,
        //       g = d.getElementsByTagName('body')[0],
        //       x = w.innerWidth || e.clientWidth || g.clientWidth;
          
        //     var result = (x*value)/100;
        //     return result;
        // },
          
        // vhTOpx(value) {
        //     var w = window,
        //       d = document,
        //       e = d.documentElement,
        //       g = d.getElementsByTagName('body')[0],
        //       y = w.innerHeight|| e.clientHeight|| g.clientHeight;
          
        //     var result = (y*value)/100;
        //     return result;
        // }
    }
});
